import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import PaginationListHOC from "../HOC/PaginationListHOC";
import './ViewMoreItems.scss';
import { Helmet } from "react-helmet";
import { Breadcrumbs } from "shared/hoc/breadcrumbs/Breadcrumbs";
import { BREADCRUMB_TYPE_CONFIG } from "shared/hoc/breadcrumbs/config";
let pagesize = 48
const filterList = {
    popular: {
        "sort": [{ "field": "bidcount", "direction": "desc" }],
        "field": ["id", "displayimageurl", "itemstatus", "itemtypeid", "itemtypename", "itemclosetime", "title", "isshippable", "saleid", "category", "categoryGroup", "thumbnailurl", "itemseourl", "bidcount"],
        "page": { "size": pagesize }
    },
    unique: {
        "sort": [{ "field": "bidcount", "direction": "desc" }],
        "field": ["id", "displayimageurl", "state", "city", "zipcode", "itemstatus", "itemtypeid", "itemtypename", "itemclosetime",
            "utc", "title", "endtime", "isshippable", "saleid", "category", 'categoryGroup', 'thumbnailurl', 'itemseourl', "bidcount", "bidprice"],
        "filter": [
            { "field": "salestatus", "value": "Started", "op": "=", "join": "AND" },
            /*  { "field": "buynowprice", "value": null, "op": "IS NOT", "join": "AND" }, */
            { "field": "itemstatus", "value": "Ready", "op": "=", "join": "AND" },
            { "field": "coolandunique", "value": 1, "op": "=", "join": "AND" },
            { "field": "isfeatured", "value": 1, "op": "=", "join": "AND" },
            // { "field": "itemtypeid", "value": 3, "op": "<", "join": "AND" },
            // { "field": "itemtypeid", "value": 1, "op": "=", "join": "OR" },
            // { "field": "itemtypeid", "value": 2, "op": "=", "join": "AND" },
        ],
        "page": { "size": pagesize }
    },
    endingsoon: {
        "sort": [{ "field": "itemclosetime", "direction": "asc" }],
        "field": ["id", "displayimageurl", "itemstatus", "itemtypeid", "itemtypename", "itemclosetime", "title", "isshippable", "saleid", "category", "categoryGroup", "thumbnailurl", "itemseourl"],
        "page": { "size": pagesize },
        "filter": [
            { "field": "salestatus", "value": "Started", "op": "=", "join": "AND" },
            { "field": "itemstatus", "value": "Ready", "op": "=", "join": "AND" },
            // { "field": "itemtypeid", "value": 3, "op": "<", "join": "AND" },
            // { "field": "itemtypeid", "value": 1, "op": "=", "join": "OR" },
            // { "field": "itemtypeid", "value": 2, "op": "=", "join": "AND" },
        ]
    },
    featured: {
        "sort": [{ "field": "itemclosetime", "direction": "asc" }],
        "field": ["id", "displayimageurl", "itemstatus", "itemtypeid", "itemtypename", "itemclosetime", "title", "isshippable", "saleid", "category", "categoryGroup", "thumbnailurl", "itemseourl"],
        "page": { "size": pagesize },
        "filter": [
            { "field": "salestatus", "value": "Started", "op": "=", "join": "AND" },
            { "field": "itemstatus", "value": "Ready", "op": "=", "join": "AND" },
            { "field": "isfeatured", "value": 1, "op": "=", "join": "AND" },
            // { "field": "itemtypeid", "value": 3, "op": "<", "join": "AND" },
            // { "field": "itemtypeid", "value": 1, "op": "=", "join": "OR" },
            // { "field": "itemtypeid", "value": 2, "op": "=", "join": "AND" },
        ]
    }
}

export default function ViewMoreItems(props) {
    const [showtype, setshowtype] = useState("")
    const [heading, setheading] = useState("")
    const [configeredData, setconfigeredData] = useState({})
    const [currentpath, setcurrentpath] = useState("")
    const params = useParams();
    useEffect(() => {
        if (currentpath != params?.type) {
            setcurrentpath(params?.type)
            getitems()
        }
        return () => { }
    }, [params])


    const getitems = async () => {
        let serarchbykey = ""
        let payload = {}
        let heading = ""
        let trendinnowStatus = ''
        setshowtype("")
        switch (params?.type) {
            case 'trending-now':
                heading = "Trending Now"
                payload = filterList?.popular
                trendinnowStatus = true
                break;
            case 'ending-soon':
                heading = "Ending Soon"
                payload = filterList?.endingsoon
                break;
            case 'featured':
                heading = "Featured"
                payload = filterList?.featured
                break;
            case 'cool-and-unique':
                heading = "Cool And Unique"
                payload = filterList?.unique
                break;
            default:
                heading = params?.type
                setshowtype(params?.type)
                serarchbykey = true
                payload = {
                    "page": { "size": pagesize },
                    data:{searchtext: params?.type}
                }
                break;
        }
        setheading(heading)
        setconfigeredData({
            payload,
            count: 4,
            pageSize: pagesize,
            type: "Item",
            history: props?.history,
            searchType: serarchbykey,
            trendingnow: trendinnowStatus,
            heading:heading
        })
    }

    return (
        <>
            <Helmet>
                <title>CTBids | {heading}</title>
            </Helmet>
        <div className="d-flex flex-column flex-grow-1" >
            {
                params.type ? 
                <div className="d-flex align-items-center justify-content-between">
                    <Breadcrumbs key={params.type} props={props} type={params.type == 'trending-now' ? BREADCRUMB_TYPE_CONFIG.TRENDING_NOW : params.type == 'ending-soon' ? BREADCRUMB_TYPE_CONFIG.ENDING_SOON : BREADCRUMB_TYPE_CONFIG.SEARCH} options={{ searchKey: params.type ? params.type : null }} />
                </div> : null
            }
           {showtype != "" && <div className="d-flex align-items-center clickable mt-3" style={{ marginLeft: '90px', fontSize: "18px" }}>
                <div className="text-bold">Showing results for: <span className="searchkey"> {showtype}</span></div>
            </div>}
            <div className="category-container flex-grow-1">
               
                <PaginationListHOC
                    config={configeredData}
                    emptyCont={"No results found"}
                />

            </div>
        </div>
        </>
    )
}